export interface Testimonial {
  name: string;
  position: string;
  avatar: string;
  logo: string;
  desc: string;
}

// tslint:disable: max-line-length
export const Testimonials: Testimonial[] = [
  {
    name: 'Vivek Sinha',
    position: 'Marketing Analytics Manager',
    avatar: 'vivek.jpg',
    logo: 'github.png',
    desc:
      'Alex has been the lead designer for quflip.com and has done a phenomenal job. Alex\'s creative ability combined combined with clarity of thought always results in outstanding designs both from a creativity perspective as well as UX perspective. He continually researched the best UX practices and presented a nearly complete idea reducing the back and forth by a lot. His designs for our startup were received by extreme enthusiasm by our customers, investors as well as our internal stakeholders. He continues to serve as the lead designer for us for a (year and half now) and I have full confidence in recommending Alex to any companies looking to set themselves apart from the crowd with a fresh, modern and creative design that inherently helps make the product better! Thank you, Alex!',
  },
  {
    name: 'Victor Sarmin',
    position: 'Project Manager',
    avatar: 'sarmin.jpeg',
    logo: 'crewguru.png',
    desc:
      'I worked with Alexander on the CrewGuru project. Only positive emotions from teamwork. A good vision of the project in general and in details. His perfectionism made it possible to see the problem, even in the early stages. As a PM, it was pleasant for me to work with a person who understands what self-organization is and how to focus on results. I highly recommend Alexander as a high-level specialist.',
  },
  {
    name: 'Jason Bell',
    position: 'Founder',
    avatar: 'jasonbell.jpeg',
    logo: 'crewguru.png',
    desc:
      'Alex is amazing! I cannot say enough good things about Alex. While his skills as a designer are genius, and his abilities as a front end developer are superior; I have to say he is the nicest guy and so easy to work with. I hope we work together for a very long time.',
  },
];



// WEBPACK FOOTER //
// ./src/app/_data/testimonials.ts